import { useSelector } from "react-redux";

import { InventorySparesFilterPage } from "../inventorySparesFilterPage/InventorySparesFilterPage";
import { InventorySparesTablePage } from "../inventorySparesTable/InventorySparesTablePage";
import { CategoryPageSkeleton } from "../../../../component/skeleton/CategoryPageSkeleton";

import { selectInventorySpareFilterState } from "../../../../store/inventory/inventorySparesSlice";


import {
  selectInventorySpares,
  useGetInventorySparesListQuery,
} from "../../../../services/inventory/spares/inventorySpareApiSlice";
import classes from "./inventorySparesListingPage.module.css";

export const InventorySparesListingPage = () => {
  const filters = useSelector(selectInventorySpareFilterState);

  const { isLoading, isSuccess, refetch } = useGetInventorySparesListQuery({
    seller_id: filters.seller_id,
    status: filters.status,
  });

  const tableData = useSelector(selectInventorySpares);

  if (isLoading) return <CategoryPageSkeleton />;

  return isSuccess ? (
    <div className={classes.box}>
      <InventorySparesFilterPage filters={filters} />
      <InventorySparesTablePage data={tableData} refetch={refetch} />
    </div>
  ) : null;
};
